export const formatInteger = (n: number): string => n.toLocaleString("es-CO");

export const formatRatio = (n: number, decimals = 2): string =>
  n.toLocaleString("es-CO", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

export const formatPercentage = (n: number, decimals = 1): string =>
  `${(n * 100).toLocaleString("es-CO", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}%`;
